import {Inject, Pipe, PipeTransform} from '@angular/core';
import {Locale} from '@aztrix/models';
import {BehaviorSubject} from 'rxjs';

import {LOCALE} from '@aztrix/translate';
import {formatDate} from '../util/date.util';

/**
 * Transforms a Date object into a date formatted string.
 **/
@Pipe({name: 'formatDate', pure: false})
export class FormatDatePipe implements PipeTransform {
  constructor(
    @Inject(LOCALE)
    private _locale$: BehaviorSubject<Locale>
  ) {}

  transform(value: string | number | Date | undefined | null): string {
    return formatDate(value, this._locale$.value);
  }
}
